<template>
    <be-spinner class="text-center p-8" v-if="!$slots.default"/>
    <div v-else>
        <div class="email-inbox-header">
            <div class="row">
                <div class="col-lg-6">
                    <div class="email-title">
                        <span :class="`icon mdi mdi-${icon}`" v-if="icon"></span>
                        &nbsp;{{title}}
                        <span class="new-messages" v-if="total">({{total}} total)</span>  </div>
                </div>
            </div>
        </div>

        <div class="email-list">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            icon: String,
            title: String,
            total: Number,
        },
    };
</script>
